export default ({ app, $config }) => {
  if ($config.newRelicEnabled && $config.newRelicSnippet) {
    app.head.script.push({
      hid: 'newrelic',
      src: `/${$config.newRelicSnippet}`,
      defer: true,
      type: 'text/javascript',
    })
  }
}
